import CategoryPage from './Category.container';
import { getLayoutProps } from './Category';

export { getLayoutProps as getCategoryContentLayoutProps };
export type { CategoryProps } from './Category';
export default CategoryPage;
